import * as types from 'model/actionTypes'

export function receiveTours (tours: {}) {
  return {
    type: types.RECEIVE_TOURS,
    tours
  }
}
